module.exports = __webpack_public_path__ + "static/media/m_hairstyle_sideswept_front_shadow.c9c12419.png";